<script lang="ts" setup>
  import { useQuery } from '@tanstack/vue-query'

  import { useGolfsService } from '~/core/services'

  /*
  * HOW TO USE
  <iframe src="https://{host}/embed/golfs/{gold_id}?color=ff8800&referer_code=REFERER"
          width="300"
          height="490"
          allow="geolocation"
          frameborder="0" >
  </iframe>
  * */

  const route = useRoute()
  const { getGolf } = useGolfsService()

  definePageMeta({
    layout: 'iframe',
  })

  const golfId = computed(() => ('golfId' in route.params) ? route.params.golfId as string : '')

  const canFetchGolf = computed(() => !isNaN(parseInt(golfId.value)))

  const { data: golf } = useQuery({
    enabled: canFetchGolf,
    queryKey: ['golf', golfId],
    queryFn: () => getGolf(golfId.value),
  })

  const golfCourses = computed(() => golf.value?.data?.courses ?? [])
  const golfName = computed(() => golf.value?.data?.name ?? '')

  </script>

<template>
  <div class="p-embed">
    <GolfDetailReservation
      :courses="golfCourses"
      :golf-name="golfName"
      embed
    />
  </div>
</template>
<style scoped>
.p-embed {
  width: 100%;
  height: 100%;
  background: var(--color-secondary-light);

  .c-golf-detail-reservation {
    top: 0;
    width: 100%;
    max-width: 800px;
    height: 100%;
    max-height: 100%;
    align-self: initial;
    margin: 0 auto;
  }
}
</style>
